import React, { ReactElement } from 'react';
import { StepConnector, StepConnectorProps } from '@mui/material';

const styles = {
  alternativeLabel: {
    top: 2,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      backgroundColor: 'customStyling.highlightColor',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: 'customStyling.highlightColor',
    },
  },
  line: {
    height: 2,
    border: 0,
    backgroundColor: 'grey.light',
    borderRadius: '1px',
  },
} as const;

const StyledStatusesConnector = (props: StepConnectorProps): ReactElement => <StepConnector sx={styles} {...props} />;

export default StyledStatusesConnector;
